const SearchParamChangedEvent = require('@adobe-fonts/site/events/SearchParamChangedEvent.js');

const SPECTRUM_BREAKPOINT_SMALL = 768;
const SPECTRUM_BREAKPOINT_MEDIUM = 1280;
const SPECTRUM_BREAKPOINT_LARGE = 1768;

/**
 * @ngInject
 */
function SearchResultsController($document, $window, DataService, FamilyAutocompleteSearchService, FavoritesService, DialogService, UserPrefsService) {
  this.$document = $document;
  this.$window = $window;
  this.DataService = DataService;
  this.FamilyAutocompleteSearchService = FamilyAutocompleteSearchService;
  this.FavoritesService = FavoritesService;
  this.DialogService = DialogService;
  this.UserPrefsService = UserPrefsService;
  this._preloadData();
}

/**
 * Returns localized example text
 *
 * @return {Object}
 */
SearchResultsController.prototype.getExampleText = function(family) {
  var viewType = 'list';
  if (family.filters != null && family.filters.indexOf('ka:ko') >= 0) {
    viewType += '_kana';
  }
  return {
    size: 40,
    value: this.textSamples[family.display_font.default_language][viewType]
  };
};

SearchResultsController.prototype._webComponents_initSearchBar = function() {
  var self = this;
  var searchBar = self.$document.find('af-search-bar')[0];
  if (!searchBar) {
    return;
  }

  searchBar.addEventListener(SearchParamChangedEvent.EVENT_NAME, function(event) {
    self.FamilyAutocompleteSearchService.get(event.detail.searchParam).then(function(response) {
      searchBar.results = response.data;
    });
  });
};

/**
 * Toggles tooltip offset by window width
 *
 * @return {String}
 */
SearchResultsController.prototype.getVisualSearchTooltipOffset = function() {
  if (this.$window.innerWidth >= SPECTRUM_BREAKPOINT_LARGE) {
    return null;
  }
  if (this.$window.innerWidth >= SPECTRUM_BREAKPOINT_MEDIUM) {
    return '32';
  }
  if (this.$window.innerWidth >= SPECTRUM_BREAKPOINT_SMALL) {
    return '24';
  }
  return '16';
};

/**
 * Preload data using DataService.
 * @private
 */
SearchResultsController.prototype._preloadData = function() {
  var self = this;
  self._webComponents_initSearchBar();

  self.DataService.get('/neue/preloaded_family_data').then(function (data) {
    self.families = data.familiesData.families;
    self.textSamples = data.textSampleData.textSamples;
  });
  self.DataService.get('/spectrum/search_navigation_tabs').then(function (data) {
    self.navigationTabs = data.navigationTabs;
    for (var i in data.navigationTabs) {
      if (data.navigationTabs[i].id === data.currentTabId) {
        self.currentTab = data.navigationTabs[i];
        break;
      }
    }
  });
};

module.exports = SearchResultsController;
